import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';

import Footer from '../../Components/Footer/Footer';

class ReportsPage extends Component {

  render() {
    return (
      <main className="page-content">
        <div className="normal-page-header">
          <h1 className="left">Reports</h1>
          <div className="clear" />
        </div>
        <section className="page-content-items">
          <h4>Fuel Sales Report</h4>
          <h5>{dateFormat(new Date(), 'fullDate')}</h5>
          <Link
            to={{ pathname: '/reports/fuelOrders' }}
            href={{ pathname: '/reports/fuelOrders' }}
            className="btn btn-medium btn-primary"
            style={{marginRight: '20px' }}
            params={{ fboId: this.props.fboId }}
          >
            Fuel Orders Report
          </Link>
          <Link
            href={{ pathname: '/reports/fuelTrucks' }}
            to={{ pathname: '/reports/fuelTrucks' }}
            className="btn btn-medium btn-primary"
            params={{ fboId: this.props.fboId }}
          >
            Truck Reports
          </Link>
          <br />
          <Link
            href={{ pathname: '/reports/monthlyOil' }}
            to={{ pathname: '/reports/monthlyOil' }}
            className="btn btn-medium btn-primary"
            params={{ fboId: this.props.fboId }}
            style={{marginRight: '20px' }}
          >
            Monthly Oil Report
          </Link>
          <Link
            href={{ pathname: '/reports/customer' }}
            to={{ pathname: '/reports/customer' }}
            className="btn btn-medium btn-primary"
            params={{ fboId: this.props.fboId }}
          >
            Customer Orders Report
          </Link>
        </section>
        <Footer />
      </main>
    );
  }
}


// App.contextTypes = {
//   router: React.PropTypes.object
// };

export default ReportsPage




// WEBPACK FOOTER //
// ./src/Containers/Reports/ReportsPage.js